// src/components/avatar.js

// 🔹 Use the S3 URL as the canonical default avatar
export const DEFAULT_AVATAR =
  "https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/avatars/avatar_alien_white.jpeg";

/** Normalize any avatar value from DB into a displayable URL. */
export const resolveAvatarUrl = (raw) => {
  if (!raw) return DEFAULT_AVATAR;
  const trimmed = String(raw).trim().toLowerCase();
  if (!trimmed || trimmed === "none") return DEFAULT_AVATAR;

  // if some old DB values still look like local build paths, fall back to default
  if (trimmed.includes("/static/media/")) {
    return DEFAULT_AVATAR;
  }

  // strip query strings so we don't keep stale versions
  return String(raw).split("?")[0];
};
